/**
 * Created with IntelliJ IDEA.
 * User: danielr
 * Date: 5/9/13
 * Time: 2:21 PM
 * To change this template use File | Settings | File Templates.
 *
 * the title view (in the top of the component)
 */
define(function (require) {
    "use strict";

    var Marionette = require('marionette');
    var Logger = require('logger');
    var template = require('ui/tooltip/templates/tooltip.tmpl');
    var SecureUtilities = require("infra-util/SecureUtilities");
    var PositionUtils = require('ui/PositionUtils');
    var _ = require("underscore");
    var $ = require("jquery");

    var AWAY_POSITION = "-999999px";

    var TooltipView = Marionette.ItemView.extend({
        template:template,
        el: ".tooltipContainer",
        ui:{
            tooltip: ".tooltip",
            text: ".content"
        },

        customTemplateHelpers : function () {
            var escapedText = SecureUtilities.escapeForHtmlContent(this.model.get("text"));
            var textToRender = SecureUtilities.unescapeBRForHtml(escapedText);
            return {
                safeText : textToRender
            };
        },

        initialize:function (options) {
            this.logger = Logger.getLogger('Tooltip');
        },

        initializeMaps: function(){
            if (_.isUndefined(this.positionMap)){
                this.positionMap = {};
                this.positionMap[this.config.POSITION.TOP] = PositionUtils.PositionEntity.POSITION.TOP;
                this.positionMap[this.config.POSITION.BOTTOM] = PositionUtils.PositionEntity.POSITION.BOTTOM;
                this.positionMap[this.config.POSITION.LEFT] = PositionUtils.PositionEntity.POSITION.LEFT;
                this.positionMap[this.config.POSITION.RIGHT] = PositionUtils.PositionEntity.POSITION.RIGHT;
            }
            if (_.isUndefined(this.alignMap)){
                this.alignMap = {};
                this.alignMap[this.config.ALIGN.LEFT] = PositionUtils.PositionEntity.ALIGN.LEFT;
                this.alignMap[this.config.ALIGN.RIGHT] = PositionUtils.PositionEntity.ALIGN.RIGHT;
                this.alignMap[this.config.ALIGN.MIDDLE] = PositionUtils.PositionEntity.ALIGN.MIDDLE;
                this.alignMap[this.config.ALIGN.TOP] = PositionUtils.PositionEntity.ALIGN.TOP;
                this.alignMap[this.config.ALIGN.BOTTOM] = PositionUtils.PositionEntity.ALIGN.BOTTOM;
            }
        },

        /***
         * setViewProperties: set the options for the tooltip view
         * @param options
         */
        setViewProperties: function(options, config){
            this.settings = options;
            this.config = config;
            this.initializeMaps();
        },

        /***
         *  onRender: renders the tooltip.
         *  we first reset the current css class and apply the new ones
         */
        onRender:function () {
             this.showTooltip();
        },

        /***
         * setTheme: set the theme class
         */
        setTheme: function(){
            if (!_.isUndefined(this.settings.theme)){
                this.ui.tooltip.addClass(this.settings.theme);
            }
            else if ($(this.settings.el).closest(this.config.cls.region.dark).length > 0){
                this.ui.tooltip.addClass(this.config.cls.theme.dark);
            }
        },

        /***
         * setIcon: set the icon class
         */
        setIcon:function(){
             if (!_.isUndefined(this.settings.icon)){
                 this.ui.tooltip.addClass(this.settings.icon);
             }
        },

        onPositionCalculated: function(pos){
            if (pos.isValid){
                this.ui.tooltip.addClass(pos.cls);
                this.ui.tooltip.css({"top": pos.top, "left": pos.left});
            }
            else {
                this.logger.error(pos.err);
                this.logger.graph({ name: "UIComponents:TooltipView:onPositionCalculatedPositionErr"});
            }
        },

        /***
         *  setPosition: sets the position of the tooltip
         */
        setPosition: function(){
            PositionUtils.position({
                targetEl: this.settings.el,
                floatingEl: this.ui.tooltip,
                position: this.positionMap[this.settings.position],
                align: this.alignMap[this.settings.align]
            }, _.bind(this.onPositionCalculated, this));
        },

        /***
         * hideTootltip: hides the tooltip
         */
        hideTootltip: function(){
            if (_.isObject(this.ui.tooltip)){
                this.ui.tooltip.hide();
            }
        },

        moveTooltipAway: function(){
            if (_.isObject(this.ui.tooltip)){
                this.ui.tooltip.css("left", AWAY_POSITION);
            }
        },

        setCss: function(){
            this.ui.tooltip.removeClass();
            this.ui.tooltip.addClass("tooltip");


            // Very long words might not break in some browsers - break them
            this.ui.text.toggleClass("break-all", this.ui.text[0].clientWidth > this.ui.tooltip[0].clientWidth);
        },

        showTooltip: function(){
            //this.ui.tooltip.show();
            this.setCss();
            this.setTheme();
            this.setIcon();
            this.setPosition();
        }
    });

    return TooltipView;
});

